// modules
import React, { Component } from 'react';
import { connect } from 'react-redux'
import withStyles from "@material-ui/core/styles/withStyles";
// src
import './App.css';
import {ProductTypes} from './constants'
import PostingFlyer from './views/PostingFlyer'
import SetPackFlyer from './views/SetPackFlyer'
import SetPackPostCard from './views/SetPackPostCard'
import SetPackRecruit from './views/SetPackRecruit'

const styles = {
}

class App extends Component {
    componentDidMount() {
        // this.props.getInitialOptions()
    }
    render() {
        // const { classes } = this.props;
        const productTypeId = window.productTypeId
        return (
            <div className="App">
                {
                    (productTypeId === ProductTypes.PostingFlyer)
                    ?<PostingFlyer />
                    :(productTypeId === ProductTypes.SetPackFlyer)
                    ?<SetPackFlyer />
                    :(productTypeId === ProductTypes.SetPackPostCard)
                    ?<SetPackPostCard />
                    :(productTypeId === ProductTypes.SetPackRecruit)
                    ?<SetPackRecruit />
                    :null
                }
                {/* <button onClick={this.props.getInitialOptions}>TEST</button> */}
            </div>
        );
    }
}

// export default App;
const mapStateToProps = state => ({
    // member: state.members.one,
})

const mapDispatchToProps = dispatch => ({
    // getInitialOptions: () => dispatch(getInitialOptions()),
    // calcPrice: () => dispatch(calcPrice()),
    // getCalendar: () => dispatch(getCalendar()),
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/App.js